import * as Actions from '../actions/accounts.actions';

const initialState = [];

const accounts = (state = initialState, action) => {
  switch (action.type) {
    case Actions.GET_ACCOUNTS:
      return action.payload;

    case Actions.ADD_ACCOUNTS:
      return [...state, action.payload];

    case Actions.UPDATE_ACCOUNTS:
    case Actions.GET_ACCOUNT: {
      const index = state.findIndex(
        (account) => account.id === action.payload.id
      );
      const newState = state;
      newState[index > -1 ? index : state.length] = action.payload;
      return [...newState];
    }
    case Actions.REMOVE_ACCOUNTS: {
      return state.filter((obj) => obj.id !== action.payload.id);
    }

    default:
      return state;
  }
};

export default accounts;
